"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderMenuPopover_unstable", {
    enumerable: true,
    get: function() {
        return renderMenuPopover_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const _reactportal = require("@fluentui/react-portal");
const renderMenuPopover_unstable = (state)=>{
    (0, _reactutilities.assertSlots)(state);
    if (state.inline) {
        return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_jsxruntime.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {}),
                state.safeZone
            ]
        });
    }
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(_reactportal.Portal, {
        mountNode: state.mountNode,
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {}),
            state.safeZone
        ]
    });
};
